/**
 * CSS-переменные для цветов виджета.
 * Порядок: --sw-* (настройки) → --bs-* (Bootstrap) → дефолт.
 * Использовать в inline style и компонентах, где нужны явные цвета.
 */
export const themeTokens = {
  primary: 'var(--sw-primary, var(--bs-primary, #0d6efd))',
  secondary: 'var(--sw-secondary, var(--bs-secondary, #6c757d))',
  headerLinks: 'var(--sw-header-links, var(--sw-primary, #0d6efd))',
  headerLinksHover: 'var(--sw-header-links-hover, var(--sw-text, #212529))',
  success: 'var(--sw-success, var(--bs-success, #198754))',
  danger: 'var(--sw-danger, var(--bs-danger, #dc3545))',
  warning: 'var(--sw-warning, var(--bs-warning, #ffc107))',
  bg: 'var(--sw-bg, var(--bs-body-bg, #fff))',
  text: 'var(--sw-text, var(--bs-body-color, #212529))',
  muted: 'var(--sw-muted, var(--bs-secondary, #6c757d))',
  border: 'var(--sw-border, var(--bs-border-color, rgba(0,0,0,.15)))',
  radius: 'var(--sw-radius, var(--bs-border-radius, 0.375rem))',
  radiusModal: 'var(--sw-radius-modal, 0.75rem)',
  cartBadgeBg: 'var(--sw-cart-badge-bg, var(--sw-danger, #dc3545))',
  cartBadgeText: 'var(--sw-cart-badge-text, #fff)',
  surfaceBg: 'var(--sw-surface-bg, var(--sw-bg, #fff))',
  surfaceBorder: 'var(--sw-surface-border, var(--sw-border, rgba(0,0,0,.15)))',
  surfaceShadow: 'var(--sw-surface-shadow, var(--sw-shadow, 0 0.5rem 1rem rgba(0,0,0,.15)))',
  subscribeModalWidth: 'var(--sw-subscribe-modal-width, 420px)',
  hover: 'var(--bs-light, #f8f9fa)',
  overlay: 'var(--sw-overlay-backdrop-color, var(--sw-overlay, rgba(0,0,0,0.5)))',
} as const;
